<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">search fileopened based on date</small>
      </legend>
      <form @submit.prevent="loadFileopenedDate()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Start date</label>
              <input type="date" class="form-control from_date" placeholder="from date" required />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>End date</label>
              <input type="date" class="form-control end_date" placeholder="end date" required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary btn-block fileopenedDate btn-rounded">
              <i class="fa fa-search"></i> Search
            </button>
            <button type="button" class="btn btn-primary btn-block fileopenedDateLoader btn-rounded">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
            </button>
          </div>
          
        </div>
      </form>

      <p></p>
      
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
 
  methods: {
    ...mapActions(["loadFileopenedDate"]),

   
  }
};
</script>
<style scoped>
.fileopenedDateLoader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/reports/fileopeneddate.vue